/* =====================================================
   Luxury Best Sellers — interactions
   - IntersectionObserver stagger reveal
   - Pointer-tracking glow (desktop, fine pointer only)
   - Wishlist toggle (UI-only placeholder, ready for backend)
   - Respects prefers-reduced-motion
   ===================================================== */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initSection(section) {
    if (section.dataset.lbsInit === '1') return;
    section.dataset.lbsInit = '1';

    var reveals = section.querySelectorAll('[data-lbs-reveal]');
    var cards = section.querySelectorAll('[data-lbs-card]');
    var wishlistBtns = section.querySelectorAll('[data-lbs-wishlist]');

    /* ---------- Reveal ---------- */
    if (reduceMotion || !('IntersectionObserver' in window)) {
      reveals.forEach(function (el) { el.classList.add('is-visible'); });
      cards.forEach(function (el) { el.classList.add('is-visible'); });
    } else {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            io.unobserve(entry.target);
          }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
      reveals.forEach(function (el) { io.observe(el); });
      cards.forEach(function (el) { io.observe(el); });
    }

    /* ---------- Pointer glow (desktop only) ---------- */
    var fine = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    if (fine && !reduceMotion) {
      cards.forEach(function (card) {
        var media = card.querySelector('.lbs-card__media');
        var glow = card.querySelector('.lbs-card__glow');
        if (!media || !glow) return;

        var rafId = 0;
        var px = 50, py = 50;
        function apply() {
          rafId = 0;
          glow.style.setProperty('--lbs-mx', px + '%');
          glow.style.setProperty('--lbs-my', py + '%');
        }
        card.addEventListener('pointermove', function (e) {
          var rect = media.getBoundingClientRect();
          px = ((e.clientX - rect.left) / rect.width) * 100;
          py = ((e.clientY - rect.top) / rect.height) * 100;
          if (!rafId) rafId = requestAnimationFrame(apply);
        }, { passive: true });
        card.addEventListener('pointerleave', function () {
          px = 50; py = 50;
          if (!rafId) rafId = requestAnimationFrame(apply);
        }, { passive: true });
      });
    }

    /* ---------- Wishlist (UI-only, ready for backend integration) ---------- */
    wishlistBtns.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        btn.classList.toggle('is-active');
        var active = btn.classList.contains('is-active');
        btn.setAttribute('aria-label', active ? 'Remove from wishlist' : 'Add to wishlist');
        document.dispatchEvent(new CustomEvent('luxury-best-sellers:wishlist', {
          detail: { productId: btn.getAttribute('data-product-id'), active: active }
        }));
      });
    });
  }

  function initAll(root) {
    (root || document).querySelectorAll('[data-lux-best-sellers]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
